<template>
  <Modal class="mask long-modal top-modal"  width="800"  v-model="show" :mask-closable="false" >
    <div slot="header" class="modal-header">
      应收账单明细
    </div>
 
    <div class=" pt16 pb16">
      <table-list :showPage ="false" :columns="columns" :data="tableData" :loading="loading"></table-list>
    </div>
    <div slot="footer">
    </div>
  </Modal>
</template>
 
<script type="text/ecmascript-6">
 import TableList from "components/TableList/index";

export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    tableData:{
      type:Array,
      default(){
        return []
      }
    }
  },
  watch:{
    n() {
      this.show = true
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    show:false,
    loading:false,
    columns:[
      {
      title: "应收账单编号",
      key: "billNumber",
      align: "center"
     
      },
      {
        title: "合同号",
        key: "contractCode",
        align: "center"
      
      },
      {
        title: "主合同号",
        key: "parentContractCode",
        align: "center"
      },
      {
        title: "房间/床位号",
        key: "stockNumber",
        align: "center"
      },
      {
        title: "账单期数",
        key: "periods",
        align: "center"
      },
      {
        title: "费用项",
        key: "costCodeName",
        align: "center"
      },
      {
        title: "应收金额",
        key: "receiptBillAmount",
        align: "center"
      }
    ],
   
 };
 }
}
</script>




